import StyledLink from '../StyledLink'
import {
  SYSTEM,
  WEBHOOK
} from '@eggplant/routing'
import type { Props } from '../types'

interface Params {
  uuid: string
}

const LinkToViewWebhookConfig = ({
  children,
  uuid,
  isHyperlink
}: (Props & Params)) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={`/${SYSTEM}/${WEBHOOK}/${uuid}/view`}
  >
    {children}
  </StyledLink>

export default LinkToViewWebhookConfig
